export default __webpack_public_path__ + "static/media/tried.1ca17786.svg";